import React from 'react';
import { useLocation } from 'react-router-dom';
import priceFormat from '../../../utils/showPriceFormat';
import './SuccessfullPayment.css';


const SuccessfullPayment = () => {
    const { state } = useLocation();
    const { factureNumber, transactionPrice, fullName, mobileNumber, telephone, address, DateAndTime, orderType} = state;

    const getOrderType = () => {
        if(orderType === 'scrap'){
            return 'فروش ضایعات'
        }
        else{
            return 'درخواست متخصص'
        }
    }
    return ( 
        <div className="successPage">
            <header className="header-successPage">
                <div className="background-layer-successPage"></div>
            </header>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-6 ">
                        <div className="success-icon text-center mt-2">
                            <i className="fa fa-check-circle text-success"></i>
                        </div>
                        <div className="text-center mt-3 mb-4">
                            <h5 className="text-success">سفارش با موفقیت ثبت شد</h5>
                        </div>
                        {/* <div className="line-seperator-item"></div> */}
                        <div className="d-flex flex-wrap background-success-facture">
                            <div className="col-6 font-weight-bold">نوع فاکتور : </div>
                            <div className="col-6 text-right">{getOrderType()}</div>
                            <div className="col-6 font-weight-bold">شماره فاکتور : </div>
                            <div className="col-6 text-right">{factureNumber}</div>
                            <div className="col-6 font-weight-bold">مبلغ نهایی تراکنش : </div>
                            <div className="col-6 text-right">{priceFormat(transactionPrice)} تومان</div>
                            <div className="col-6 font-weight-bold">نام و نام خانوادگی : </div>
                            <div className="col-6 text-right">{fullName}</div>
                            <div className="col-6 font-weight-bold">شماره موبایل : </div>
                            <div className="col-6 text-right">{mobileNumber}</div>
                            <div className="col-6 font-weight-bold">تلفن ثابت : </div>
                            <div className="col-6 text-right">{telephone}</div>
                            <div className="col-6 font-weight-bold">آدرس : </div>
                            <small className="col-12 col-md-6 text-md-right">{address}</small>
                            <div className="col-5 font-weight-bold">تاریخ ثبت : </div>
                            <small className="col-7 text-right" style={{direction:'ltr'}}>{DateAndTime}</small>
                        </div>
                    </div>
                </div>

            </div>
        </div>
     );
}



export default SuccessfullPayment;